import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { faqs } from "../../data/landing";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-129" data-mp="2z2z18ykci74t">
      <div className="mx-auto max-w-3xl" data-id="element-130" data-mp="2z3h268hyd9j2">
        <h2 className="text-center font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-131" data-mp="3ms9qbisc2d34">Frequently asked questions</h2>

        <ul className="mt-10 divide-y divide-navy/10 border-y border-navy/10" data-id="element-132" data-mp="3rrcxp9vscve9">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-133" data-mp="3i1bbknmztn1z" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left text-[17px] font-bold text-navy focus:outline-none focus-visible:text-skydeep" data-id="element-134" data-mp="3i09w86yy2eeg">
                  {f.q}
                  <PlusIcon className={`h-5 w-5 shrink-0 text-skydeep transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-135" data-mp="1vsopkr3uk3f6" />
                </button>
                <AnimatePresence initial={false} data-id="element-136" data-mp="25nyr7dqc28sf">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-137" data-mp="2jfdcjr7pqm2n">
                      <p className="pb-5 text-[16px] leading-relaxed text-ink/75" data-id="element-138" data-mp="z0l63urdr5mt">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-12" data-id="element-139" data-mp="1js07iah9y0ht">
          <CTAButton label="I'm ready — get Case Lab™" data-id="element-140" data-mp="1ns0u4iej1hzy" />
        </div>
      </div>
    </section>;
}